import { render, staticRenderFns } from "./AuthHometaxAgent.vue?vue&type=template&id=36faf706&"
import script from "./AuthHometaxAgent.vue?vue&type=script&lang=js&"
export * from "./AuthHometaxAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports